<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const router = useRouter()

onMounted(() => {
  router.replace({ name: 'users-register-surgeon-secretary' })
})
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-height: 100vh;"
  >
    <VProgressCircular
      indeterminate
      color="primary"
    />
  </div>
</template>
